import { SHIPMENT_STATUS, DEFAULT_EMPTY } from './../../../constants/constants';
import { formatDate, extractTime } from './../../../utils/DateTime';
import _get from 'lodash/get';

export const functionDisabled = (shipmentStatus, disabledStatuses) => {
  return disabledStatuses.includes(shipmentStatus);
};

export const functionEnabled = (shipmentStatus, enabledStatuses) => {
  return enabledStatuses.includes(shipmentStatus);
};
export const fieldsToPick = [
  'id',
  'carrierWasLate',
  'plannedFromTimeLocal',
  'plannedToTimeLocal',
  'actualToTimeLocal',
  'openFromTimeLocal',
  'openToTimeLocal',
  'actualTimeLocal',
  'locationName',
  'locationAddress'
];

export const previousStepMenuText = (t, shipmentStatusId) => {
  const statuses = {
    [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: t('Ready to Tender'),
    [SHIPMENT_STATUS.IN_TRANSIT]: t('Waiting for Pickup'),
    [SHIPMENT_STATUS.DELIVERED]: t('In Transit')
  };

  return `${t('Back to')} ${statuses[shipmentStatusId]}`;
};

export const READ_ONLY_STATUSES = [
  SHIPMENT_STATUS.READY_TO_TENDER,
  SHIPMENT_STATUS.CANCELLED,
  SHIPMENT_STATUS.EXCEPTION
];
export const ALLOW_EXCEPTIONS = [
  SHIPMENT_STATUS.IN_TRANSIT,
  SHIPMENT_STATUS.WAITING_FOR_PICKUP,
  SHIPMENT_STATUS.CANCELLED
];

export const buildMenu = (shipment, org, actions, t) => {
  const {
    shipmentStatusId,
    previousShipmentStatusId: previousStatus
  } = shipment;

  const ACTIVE_SHIPMENT_STATUSES = [
    SHIPMENT_STATUS.WAITING_FOR_PICKUP,
    SHIPMENT_STATUS.IN_TRANSIT,
    SHIPMENT_STATUS.DELIVERED
  ]; //I named this to mean, something that is an active shipment goign through the lifecycle
  const RESUME_SHIPMENT_MENU_TITLES = {
    [SHIPMENT_STATUS.READY_TO_TENDER]: t('Cancel Tender'),
    [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: t('Waiting for pickup'),
    [SHIPMENT_STATUS.IN_TRANSIT]: t('In Transit'),
    [SHIPMENT_STATUS.DELIVERED]: t('Delivered')
  };
  const menuOptions = [];
  if (allowAutoTender(shipment, org)) {
    menuOptions.push({
      label: t('Tender Shipment'),
      action: actions.tenderShipment
    });
  }
  if (shipmentStatusId === SHIPMENT_STATUS.EXCEPTION) {
    menuOptions.push({
      label: RESUME_SHIPMENT_MENU_TITLES[previousStatus],
      action: actions.resumeShipment
    });
  }
  if (functionEnabled(shipmentStatusId, ACTIVE_SHIPMENT_STATUSES)) {
    menuOptions.push({
      label: previousStepMenuText(t, shipmentStatusId),
      action: actions.revert
    });
    if (functionEnabled(shipmentStatusId, ALLOW_EXCEPTIONS)) {
      menuOptions.push({
        label: t('Exception'),
        action: actions.exception
      });
    }
  }
  if (!functionDisabled(shipmentStatusId, [SHIPMENT_STATUS.CANCELLED])) {
    menuOptions.push({
      label: t('Cancel'),
      action: actions.cancel
    });
  }

  menuOptions.push({
    label: t('Delete'),
    action: actions.delete
  });

  return menuOptions;
};
export const buildCancellationReasons = reasonsList => {
  const cancellationReasons = [];
  reasonsList.forEach(reason => {
    if (reason.active) {
      cancellationReasons.push({
        value: reason.id,
        title: reason.name
      });
    }
  });
  return cancellationReasons;
};
export const buildEstimatedDateString = (inputDate, fromTime, toTime) => {
  const estimatedDate = formatDate(inputDate);
  if (estimatedDate === DEFAULT_EMPTY) {
    return DEFAULT_EMPTY;
  }

  const openFromTime = extractTime(fromTime);
  const openToTime = extractTime(toTime);
  if (openFromTime !== DEFAULT_EMPTY && openToTime !== DEFAULT_EMPTY) {
    return `${estimatedDate} (${openFromTime} - ${openToTime})`;
  }
  return `${estimatedDate}`;
};

export const allowTender = shipment => {
  switch (shipment.shipmentStatusId) {
    case SHIPMENT_STATUS.READY_TO_TENDER:
    case SHIPMENT_STATUS.TENDER_REJECTED:
      return true;
    default:
      return false;
  }
};

export const allowAutoTender = (shipment, org) => {
  const carrierSupportsAutoTender = _get(
    shipment,
    'selectedShipmentRate.carrier.supportsAutoTender',
    false
  );

  if (org.config.autoTenderEnabled && carrierSupportsAutoTender)
    return allowTender(shipment);

  return false;
};
